export enum ReportModalEditModeEnum {
  Edit = "Edit",
  Create = "Create",
}
